import { render, staticRenderFns } from "./tarazo.vue?vue&type=template&id=290c39af&"
import script from "./tarazo.vue?vue&type=script&lang=js&"
export * from "./tarazo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports